import { IMSId, IMSObject } from './ims-object';

export interface TagTemplateDTO {
  id: number;
  secondaryid: number;
  label: string;
}

export class TagTemplate extends IMSObject {
  static fromDto(dto: TagTemplateDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/TagTemplate',
      },
      dto.label
    );

    obj.databag = databag ? databag : dto;
    return obj;
  }

  public get name(): string {
    return this.databag.name;
  }
  public set name(value: string) {
    this.databag.name = value;
  }

  public get description(): string {
    return this.databag.description;
  }
  public set description(value: string) {
    this.databag.description = value;
  }

  constructor(
    public readonly id: IMSId,
    label: string
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/TagTemplate');
  }
}
